import { NgModule } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RciCommonModule } from '@rci/common';
import { BuyflowModule } from '@rci/self-serve-fido/buyflow/buyflow.module';
import { AccountSelectorModalModule } from '@rci/self-serve-fido/shared/account-selector-modal/account-selector-modal.module';
import { AuthenticationService } from '@rci/self-serve-fido/shared/authentication/authentication.service';
import { ApiEndpointService } from '@rci/self-serve-shared';
import { StateService } from '@rci/state-service';
import { LOCAL_STORAGE } from '@rci/storage/local-storage.service';
import { AccessoriesConfigService, AccessoriesSummaryStoreModule } from '@rogers/self-serve-accessories';
import { COMMON_APP_CONFIG } from '@rogers/self-serve-common';
import { AccountDetailStoreModule, AccountListStoreModule } from '@rogers/self-serve-common/account';
import { AlertStoreModule } from '@rogers/self-serve-common/alert';
import { AlertContentStoreModule } from '@rogers/self-serve-common/alert-content';
import { BillingDetailStoreModule } from '@rogers/self-serve-common/billing-detail';
import { BrtSwitchStoreModule } from '@rogers/self-serve-common/brt-switch';
import { PageContentStoreModule } from '@rogers/self-serve-common/page-content';
import { TargetedOffersStoreModule } from '@rogers/self-serve-targeted-offers';
import { AccountDetailService } from '../state/account/account-detail.service';
import { UserPermissionStoreModule } from '@rogers/self-serve-common/user-permission';
import { UserInformationStateFacade } from '../state/user-information/user-information-state.facade';
import { CommonAppConfigFactory } from './config/common-config';
import { ViewContainerRefService } from './view-container-ref/view-container-ref.service';
import { AppSettingStoreModule } from '@rogers/self-serve-common/app-setting';

@NgModule({
  imports: [
    AccessoriesSummaryStoreModule,
    AccountDetailStoreModule,
    AccountListStoreModule,
    AccountSelectorModalModule,
    AlertContentStoreModule,
    AlertStoreModule,
    AppSettingStoreModule,
    BillingDetailStoreModule,
    BrtSwitchStoreModule,
    BuyflowModule,
    PageContentStoreModule,
    RciCommonModule,
    TargetedOffersStoreModule,
    UserPermissionStoreModule,
  ],
  exports: [RciCommonModule],
  providers: [
    {
      provide: COMMON_APP_CONFIG,
      useClass: CommonAppConfigFactory,
      deps: [
        ApiEndpointService,
        AuthenticationService,
        StateService,
        ViewContainerRefService,
        TranslateService,
        UserInformationStateFacade,
        AccountDetailService,
        LOCAL_STORAGE,
      ],
    },
    {
      provide: AccessoriesConfigService,
      useClass: CommonAppConfigFactory,
      deps: [ApiEndpointService, AuthenticationService, StateService, ViewContainerRefService],
    },
  ],
})
export class SharedModule {}
